import AddStandard from "../../Components/Modals/AddStandard";
import Table from "../../Components/Table";
import { deleteStandardById, getAllStandard } from "../../Services/MasterService";

const Standard = () => {
    const columns = [
        {
            label: "Skill",
            value: "name"
        },
        {
            label: "Alias",
            value: "alias"
        },
        {
            label: "Description",
            value: "description"
        },
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddStandard data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getAllStandard}
            columns={columns}
            title={"Standard And Class Master"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteStandardById}
        />
    );
}

export default Standard;